import React, { forwardRef, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextInput } from '../TextInput/TextInput';
import { useFormContext } from './FormProvider';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

const TextInputComponent = forwardRef(({ ...props }, ref) => (
  <TextInput ref={ref} {...props} />
));

TextInputComponent.displayName = "TextInputComponent";

export const FormText = ({ 
  name,
  label,
  remoteValidate,
  validateDelay = 500,
  ...props 
}) => {
  const { 
    control,
    setError, 
    getValues,
    trigger,
    formState: { errors },
    formConfig
  } = useFormContext();

  // const [isValidating, setIsValidating] = useState(false);
  useEffect(() => {
    handleFieldChange(getValues(name))
  }, []);  
  const debouncedValidate = React.useMemo(
    () => remoteValidate && debounce(async (value) => {
      if (!value) return;
      console.log("text remote validate", value);
      
      
      const isValid = await trigger(name);
      
      if (!isValid || errors[name]) return;
      
      // setIsValidating(true);
      try {
        await remoteValidate(value);
      } catch (error) {
        setError(name, {
          type: 'remote',
          message: error.message
        });
      } finally {
        // setIsValidating(false);
      }
    }, validateDelay),
    [name, setError, trigger, errors, remoteValidate, validateDelay]
  );

  const handleFieldChange = React.useCallback(
    (value) => {
      if (remoteValidate && value) {
        debouncedValidate(value);
      }
    },
    [remoteValidate, debouncedValidate]
  );


  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // console.log("FormText", field, error);
        return (
          <TextInputComponent
            {...field}
            {...formConfig}
            {...props}
            label={label}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value);
              handleFieldChange(value);
            }}
          />
        )
      }}
    />
  );
};

FormText.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  validateRemote: PropTypes.bool,
  validateDelay: PropTypes.number,
};